import React, { useRef, useEffect } from 'react';
import Slider from "react-slick";
import OneArticle from './OneArticle';
import OneConfession from './OneConfession';
import { getInlineLoader } from '../Helpers';

export default function ArticlesSlider({ contents, type }) {
  const sliderRef = useRef(null);

  useEffect(() => {
    const slider = sliderRef.current;

		/*
    const preventTouchEvents = (e) => {
      e.stopPropagation(); // Prevent the event from reaching the parent
    };

    if (slider) {
      // Attach event listeners to prevent touch events from propagating to parent
      slider.addEventListener('touchstart', preventTouchEvents);
      slider.addEventListener('touchmove', preventTouchEvents);
      slider.addEventListener('touchend', preventTouchEvents);
    }

    return () => {
      if (slider) {
        // Clean up the event listeners when the component is unmounted
        slider.removeEventListener('touchstart', preventTouchEvents);
        slider.removeEventListener('touchmove', preventTouchEvents);
        slider.removeEventListener('touchend', preventTouchEvents);
      }
    };
		*/
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
		swipe: true,  // Enable swipe gestures
    touchThreshold: 10,  // Adjust sensitivity if needed
  };

  return (
    <div 
			ref={sliderRef}
			className='ContentSlider'
		>
      {
				(contents && contents.length > 0) ?
				<Slider {...settings}>
					
					{
						contents.map((item, i) => {
							if(type === 'article') {
                return (
                  <div key={i}>
                    <OneArticle data={item}/>
                  </div>
                )
              } else if(type === 'confession') {
                return (
                  <div key={i}>
                    <OneConfession data={item}/>
                  </div>
                )
              }
						})
					}
				</Slider>
				:
				<div style={{ width: "100%" }} className='mSupportLoading'>
					{getInlineLoader()}
				</div>
			}
    </div>
  );
}
